module.exports = __webpack_public_path__ + "img/fi-rr-angle-double-small-right-white.cd73a9c2.svg";